'use strict';

/**
 * buildScheduleSavePayload(schedule, selectedItems) — the create/patch body
 * for Schedule.create() and Schedule.prototype$patchAttributes(), extracted
 * from edit-schedule.js save() (around line 202-249).
 *
 * Per item we persist only { id, type, slug, day, hour, min }: `name` and
 * `styles` are UI-only join data added client-side when an app/playlist is
 * picked (see addAppToSchedule()/addPlaylistToSchedule() in edit-schedule.js)
 * and re-hydrated on read via AppStylesInPlaylist against the current apps
 * list (see schedules.js getData()) — they are not schedule state and must
 * not be sent to the backend.
 */
function buildScheduleSavePayload(schedule, selectedItems) {
    var items = (selectedItems || []).map(function (item) {
        return {
            id: item.id,
            type: item.type,
            slug: item.slug,
            day: item.day,
            hour: item.hour,
            min: item.min,
        };
    });

    return {
        name: schedule.name,
        items: items,
    };
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        buildScheduleSavePayload: buildScheduleSavePayload,
    };
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('scheduleSavePayload', {
        buildScheduleSavePayload: buildScheduleSavePayload,
    });
}
